import {AppMessageType} from '../components/atoms/CustomToast';
import store from '../redux/store';
import {showAlert} from '../redux/actions/globalActions';

export const showToastMessage = (type: AppMessageType, message: string, duration?: number) => {
  store.dispatch(showAlert({message, type, duration}));
};
